<template>
	<!-- 导航跳转有bug -->
	<div class="case_wrap">
		<el-container v-if='this.$route.query.typeId != undefined'>
			<el-aside width="250px">
				<el-menu default-active="/regulator" router>
					<p @click="pathFun" class="b_index">返回首页</p>
					<div class="nav_box">
						<router-link class="up" :to="{name:'RegAwait',params:{token:token},query:{typeId:typeId}}">{{typeName}}管理</router-link>
						<router-link v-if='accountLevel == 0 && false' class="ha" :class='{active:routerShow6}' :to="{name:'undistributed',params:{token:token},query:{typeId:typeId}}">未分配案件</router-link>
						<router-link class="ha" :class='{active:routerShow1}' :to="{name:'RegAwait',params:{token:token},query:{typeId:typeId}}">等待授权启动救援案件</router-link>
						<router-link class="ha" :class='{active:routerShow2}' :to="{name:'RegOffer',params:{token:token},query:{typeId:typeId}}">授权通过等待方案报价案件</router-link>
						<router-link class="ha" :class='{active:routerShow3}' :to="{name:'RegRescue',params:{token:token},query:{typeId:typeId}}">救援中案件管理</router-link>
						<router-link class="ha" :class='{active:routerShow4}' :to="{name:'Finish2',params:{token:token},query:{typeId:typeId}}">已完成案件管理</router-link>
            <router-link class="ha"  :to="{name:'waitCase',params:{token:token},query:{typeId:typeId}}">待认定保险责任案件</router-link>
					</div>
				</el-menu>
			</el-aside>
			<el-main>
				<router-view></router-view>
			</el-main>
		</el-container>
		<el-container v-else>
			<el-aside width="250px">
				<el-menu default-active="/regulator" router>
					<!--<router-link :to="{name:indexArray[usertype],params:{token:token}}" class="b_index">返回首页</router-link>-->
					<p @click="pathFun" class="b_index">返回首页</p>
					<div class="nav_box">
						<a>案件管理</a>
						<router-link :class='{active:routerShow4}' class="ha" :to="{name:'Finish2'}">已完成救援案件列表</router-link>
						<router-link :class='{active:routerShow5}' class="ha" :to="{name:'statistical'}">案件统计</router-link>
					</div>
				</el-menu>
			</el-aside>
			<el-main>
				<router-view></router-view>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import "isomorphic-fetch";
	import constants from "@/util/constants.js";
	import Promise from "promise-polyfill";

	if(!window.Promise) {
		window.Promise = Promise;
	}
	export default {
		data() {
			return {
				token:JSON.parse(window.localStorage.getItem("data")).data,
				insti:JSON.parse(window.localStorage.getItem("insti")),
				accountLevel:JSON.parse(window.localStorage.getItem("accountLevel")).data,
				typeId: this.$route.query.typeId,
				typeName: "",
				routerShow1:false,
				routerShow2:false,
				routerShow3:false,
				routerShow4:false,
				routerShow5:false,
				routerShow6:false,
			};
		},
		methods: {
			back() {},
			routerFun(to){
				var router=to.name;
				this.routerShow1=false;
				this.routerShow2=false;
				this.routerShow3=false;
				this.routerShow4=false;
				this.routerShow5=false;
				if(router == 'Regparinf'){
					this.routerShow1=true;
				} else if(router == 'Regresstep' || router == 'Reglookinf'){
					this.routerShow2=true;
				}else if(router == 'resstepGoing'){
					this.routerShow3=true;
				}else if(router == 'RegFinishPar2'){
					if(this.$route.query.tj == undefined){
						this.routerShow4=true;
						this.routerShow5=false;
					}else{
						this.routerShow4=false;
						this.routerShow5=true;
					}

				}
			},
			pathFun(){
				this.$router.push({name:'mainPaseRegulator'})
			}
		},
		mounted() {
			console.log(this.$route)
			let that = this;
			if(this.$route.query.typeId != undefined){
			fetch(constants.domain + "rescue/service_plan/get_service", {
					method: "POST",
					body: `token=${this.token ||JSON.parse(window.localStorage.getItem("data")).data}&id=${this.typeId}`,
					mode: "cors",
					headers: {
						"Content-Type": "application/x-www-form-urlencoded"
					}
				})
				.then(function(res) {
					return res.json();
				})
				.then(function(data) {
					if(data.code == 0) {
						that.typeName = data.obj.name;
					} else {
						console.log("center case index getService error:" + data.code);
					}
				});
			}
			this.routerFun(this.$route)
		},
		updated() {
			this.typeId = this.$route.query.typeId;
			this.name = this.$route.query.name;
		},
		watch:{
			$route(to){
				this.routerFun(to)
			}
		}
	};
</script>

<style scoped>
	@import url(../../css/caseindex.css);
	.active {
		background: #00abfa;
		color: #fff;
	}
	.router-link-active:hover, .active:hover{color: #fff;background: #00abfa}
</style>



// WEBPACK FOOTER //
// src/components/regulator/Caseindex.vue